import { defineMessages } from 'react-intl';
import _forEach from 'lodash/forEach';

const messages = defineMessages({
  cannotBeEmpty: 'Pole nie może być puste',
});

export default (value) => {
  const result = {
    fields: {},
  };

  result.isValid = true;

  _forEach(value, (el, index) => {
    if (el === null || el === undefined || el.toString().length === 0) {
      result.fields[`answer-${index}`] = messages.cannotBeEmpty;
      result.isValid = false;
    }
  });

  return result;
};
